module.exports = __webpack_public_path__ + "static/fonts/LavaPro-MedIta.22cc0a6.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/LavaPro-MedIta.eot
// module id = JK2J
// module chunks = 0